// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineRadioGroup_root__s8AfK","label":"MantineRadioGroup_label____sTQ"};